export default (text: string) => {
  if (!text) return null;

  return text[0].toUpperCase() + text.slice(1).toLowerCase();
};
